import React, { Component } from "react";
import PropTypes from 'prop-types';

import DashboardMetricsApi from 'apis/DashboardMetrices';
import NumberMetricWrapper from './NumberMetricWrapper';
import Comparison from './Comparison';
import GoalBar from './GoalBar';
import TotalChange from './TotalChange';

class NumberMetricComponent extends Component {
  constructor() {
    super();
    this.state = {
      data: {
        count: 0,
        title: '',
        goal: 0,
        change_value: 0,
        config_data: {
          metric: '',
          value: {},
          benchmark: {}
        }
      }
    };
  }

  componentDidMount = () => {
    this.fetchMetricData();
  }

  fetchMetricData = () => {
    const { id } = this.props;
    DashboardMetricsApi.getDetails(id).then(({ data }) => {
      if (typeof data == 'string')
        return this.setState({ configData: {} });
      this.setState({ data });
    }).catch(console.log)
  }

  renderNumberComponentType = () => {
    const { data } = this.state;
    const {
      config_data: dashboardConfig,
      count,
      goal,
      change_value
    } = data;
    const { value } = dashboardConfig;
    const { benchmark } = dashboardConfig;
    const { time_range } = benchmark;
    const { type } = benchmark;
    const comparisonInterval = time_range && (time_range != 'daily') ? 'last ' + time_range.replace('ly', '') : 'yesterday';

    switch (type) {
      case 'goal':
        return <GoalBar count={count} goal={goal} />;
      case 'comparison':
        return (
          <Comparison
            count={count}
            comparisonInterval={comparisonInterval}
            changeValue={change_value}
          />
        );
      case 'total_change':
        return (
          <TotalChange
            count={count}
            comparisonInterval={comparisonInterval}
            changeValue={change_value}
          />
        );
    }
  }

  render() {
    const { id, toggleMetricsConfig } = this.props;
    const { data } = this.state;
    const { count, config_data: dashboardConfig } = data;
    const { metric, value } = dashboardConfig;
    const { time_range } = value;
    const componentData = { id, title: metric, count, dashboardConfig };
    const comparisonInterval = time_range && (time_range != 'daily') ? time_range.replace('ly', '') : 'day';
    const isAverage = value.type == "average";

    return (
      <NumberMetricWrapper
        data={componentData}
        toggleMetricsConfig={toggleMetricsConfig}
        comparisonInterval={comparisonInterval}
        isAverage={isAverage}
        timeRange={time_range}
      >
        {this.renderNumberComponentType()}
      </NumberMetricWrapper>
    )
  }
}

NumberMetricComponent.propTypes = {
  id: PropTypes.number.isRequired,
  toggleMetricsConfig: PropTypes.func.isRequired
};

export default NumberMetricComponent;



// WEBPACK FOOTER //
// ./src/components/dashboard/number/index.js